import { HIDE_WIDGET } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function hideCallingWidget() {
  return callingAPIMethodWithQueue(HIDE_WIDGET);
}